<template>
  <oct-dialog
    class="oct-selection-dialog"
    :class="[`oct-selection-dialog--${type}`,
      {
        'oct-selection-dialog--grid': grid
      }
    ]"
    ref="dialog"
    @submit="submit"
    @cancel="$emit('cancel')"
  >
    <template v-slot:title>{{ title }}</template>

    <template #tab v-if="place || type === 'user' || type === 'artist'">
      <oct-tab-bar
        :items="[
          {
            text: '登録済み',
            value: 'select'
          },
          {
            text: '手動入力',
            value: 'input'
          }
        ]"
        v-model="$data.$_octSelectionDialog_currentTab"
        v-if="place"
      />

      <oct-tab-bar
        :items="[
          {
            text: '関連',
            value: 'related'
          },
          {
            text: 'ギャラリー',
            value: 'gallery'
          },
          {
            text: 'アーティスト',
            value: 'artist'
          }
        ].concat(
          isOrganizer ? [
            {
              text: '手動入力',
              value: 'input-organizers'
            }
          ]: []
        )"
        :length="userLength"
        v-model="$data.$_octSelectionDialog_currentTab"
        v-if="type === 'user'"
      />

      <oct-tab-bar
        :items="[
          {
            text: '関連',
            value: 'related'
          },
          {
            text: 'すべて',
            value: 'all'
          }
        ].concat(
          allowedManualRegistrations.includes('artist') ? [
            {
              text: '手動入力',
              value: 'input-artist'
            }
          ] : []
        )"
        :length="allowedManualRegistrations.includes('artist') ? 3 : 2"
        v-model="$data.$_octSelectionDialog_currentTab"
        v-if="type === 'artist'"
      />
    </template>

    <!-- Artists -->
    <div v-if="type === 'artist'">
      <!-- Related -->
      <oct-list v-show="$data.$_octSelectionDialog_currentTab === 'related'">
        <oct-list-item
          v-for="(item, i) in $data.$_octSelectionDialog_relatedItems"
          :key="i"
          :title="getTitle(item)"
          :text="getText(item)"
          :media="{
            image: item.profileIcon || item.images[0] || null
          }"
          v-show="getTitle(item)"
        >
          <template v-slot:meta>
            <oct-checkbox
              type="sign"
              :value="item.id"
              v-model="$data.$_octSelectionDialog_selections"
              v-if="multiple"
            />
            <oct-radio
              :value="item.id"
              v-model="$data.$_octSelectionDialog_selections[0]"
              v-else
            />
          </template>
        </oct-list-item>
      </oct-list>

      <!-- Artists -->
      <oct-list v-show="$data.$_octSelectionDialog_currentTab === 'all'">
        <oct-list-item
          v-for="(item, i) in $data.$_octSelectionDialog_items"
          :key="i"
          :title="getTitle(item)"
          :text="getText(item)"
          :media="{
            image: item.profileIcon || item.images[0] || null
          }"
          v-show="getTitle(item)"
        >
          <template v-slot:meta>
            <oct-checkbox
              type="sign"
              :value="item.id"
              v-model="$data.$_octSelectionDialog_selections"
              v-if="multiple"
            />
            <oct-radio
              :value="item.id"
              v-model="$data.$_octSelectionDialog_selections[0]"
              v-else
            />
          </template>
        </oct-list-item>
      </oct-list>

      <!-- Artist name input if allowed -->
      <oct-form
        class="oct-profile-form__form"
        v-show="$data.$_octSelectionDialog_currentTab === 'input-artist'"
        v-if="allowedManualRegistrations.includes('artist')"
      >
        <oct-form-group label="アーティスト名">
          <oct-text-field
            v-model="$data.$_octSelectionDialog_artistName"
          />
        </oct-form-group>
      </oct-form>
    </div>

    <!-- Galleries and Artists -->
    <div v-if="type === 'user'">
      <!-- Related -->
      <oct-list v-show="$data.$_octSelectionDialog_currentTab === 'related'">
        <oct-list-item
          v-for="(item, i) in $data.$_octSelectionDialog_relatedItems"
          :key="i"
          :title="getTitle(item)"
          :text="getText(item)"
          :media="{
            image: item.profileIcon || item.images[0] || null
          }"
          v-show="getTitle(item)"
        >
          <template v-slot:meta>
            <oct-checkbox
              type="sign"
              :value="item.id"
              v-model="$data.$_octSelectionDialog_selections"
              v-if="multiple"
            />
            <oct-radio
              :value="item.id"
              v-model="$data.$_octSelectionDialog_selections[0]"
              v-else
            />
          </template>
        </oct-list-item>
      </oct-list>

      <!-- Galleries -->
      <oct-list v-show="$data.$_octSelectionDialog_currentTab === 'gallery'">
        <oct-list-item
          v-for="(item, i) in filterItems()"
          :key="i"
          :title="getTitle(item)"
          :text="getText(item)"
          :media="{
            image: item.profileIcon || item.images[0] || null
          }"
          v-show="getTitle(item)"
        >
          <template v-slot:meta>
            <oct-checkbox
              type="sign"
              :value="item.id"
              v-model="$data.$_octSelectionDialog_selections"
              v-if="multiple"
            />
            <oct-radio
              :value="item.id"
              v-model="$data.$_octSelectionDialog_selections[0]"
              v-else
            />
          </template>
        </oct-list-item>
      </oct-list>

      <!-- Artists -->
      <oct-list v-show="$data.$_octSelectionDialog_currentTab === 'artist'">
        <oct-list-item
          v-for="(item, i) in filterItems('artist')"
          :key="i"
          :title="getTitle(item)"
          :text="getText(item)"
          :media="{
            image: item.profileIcon || item.images[0] || null
          }"
          v-show="getTitle(item)"
        >
          <template v-slot:meta>
            <oct-checkbox
              type="sign"
              :value="item.id"
              v-model="$data.$_octSelectionDialog_selections"
              v-if="multiple"
            />
            <oct-radio
              :value="item.id"
              v-model="$data.$_octSelectionDialog_selections[0]"
              v-else
            />
          </template>
        </oct-list-item>
      </oct-list>

      <oct-form
        class="oct-profile-form__form"
        v-show="$data.$_octSelectionDialog_currentTab === 'input-organizers'"
        v-if="isOrganizer"
      >
        <oct-form-group label="主催者名">
          <oct-text-field
            v-model="$data.$_octSelectionDialog_artistName"
          />
        </oct-form-group>
      </oct-form>
    </div>

    <p
      v-if="$data.$_octSelectionDialog_currentTab === 'related' && !state.relatedArtists.total && type === 'artist'"
    >
      まだ関連する項目がありません
    </p>

    <!-- Common list -->
    <oct-list v-if="!grid && type !== 'artist' && type !== 'user' && $data.$_octSelectionDialog_currentTab === 'select'">
      <oct-list-item
        v-for="(item, i) in $data.$_octSelectionDialog_items"
        :key="i"
        :title="getTitle(item)"
        :text="getText(item)"
        :media="{
          image: item.profileIcon || item.images[0] || null
        }"
        v-show="getTitle(item)"
      >
        <template v-slot:meta>
          <oct-checkbox
            type="sign"
            :value="item.id"
            v-model="$data.$_octSelectionDialog_selections"
            v-if="multiple"
          />
          <oct-radio
            :value="item.id"
            v-model="$data.$_octSelectionDialog_selections[0]"
            v-else
          />
        </template>
      </oct-list-item>
    </oct-list>

    <!-- Common grid list -->
    <div
      class="oct-selection-dialog-list"
      v-if="grid && type !== 'artist' && type !== 'user' && $data.$_octSelectionDialog_currentTab === 'select'"
    >
      <div
        class="oct-selection-dialog-list-item"
        v-for="(item, i) in $data.$_octSelectionDialog_items"
        :key="i"
      >
        <div
          class="oct-selection-dialog-list-item__content"
          @click="onGridItemClick"
        >
          <oct-media
            :image="item.images && item.images.length && item.images[0] || {}"
            :lock="item.status === 'private'"
            class="oct-selection-dialog-list-item__media"
          >
            <template>
              <oct-checkbox
                type="sign"
                :ordered="true"
                :value="item.id"
                v-model="$data.$_octSelectionDialog_selections"
                class="oct-selection-dialog-list-item__action"
                v-if="multiple"
              />
              <oct-radio
                :value="item.id"
                :ordered="true"
                v-model="$data.$_octSelectionDialog_selections[0]"
                class="oct-selection-dialog-list-item__action"
                v-else
              />
            </template>
          </oct-media>

          <div class="oct-selection-dialog-list-item__text">
            <span class="oct-selection-dialog-list-item__primary-text">{{ getTitle(item) }}</span>
            <span class="oct-selection-dialog-list-item__secondary-text">{{ getText(item) }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Venue -->
    <div
      class="oct-selection-dialog__venue"
      v-if="$data.$_octSelectionDialog_currentTab === 'input'"
    >
      <oct-form class="oct-profile-form__form">
        <oct-form-group label="ギャラリー名：日本語">
          <oct-text-field
            v-model="$data.$_octSelectionDialog_venue.tradeName"
          />
        </oct-form-group>

        <oct-form-group label="ギャラリー名：英語">
          <oct-text-field
            v-model="$data.$_octSelectionDialog_venue.tradeNameEN"
          />
        </oct-form-group>

        <oct-form-group
          label="拠点"
        >
          <oct-text-field
            placeholder="Tokyo, Japan"
            v-model="$data.$_octSelectionDialog_venue.base"
          />
        </oct-form-group>

        <oct-form-group label="ウェブサイト">
          <oct-text-field
            placeholder="https://"
            v-model="$data.$_octSelectionDialog_venue.website"
          />
        </oct-form-group>

        <oct-form-group label="住所：日本語">
          <oct-text-field
            v-model="$data.$_octSelectionDialog_venue.address"
          />
        </oct-form-group>

        <oct-form-group label="住所：英語">
          <oct-text-field
            v-model="$data.$_octSelectionDialog_venue.addressEN"
          />
        </oct-form-group>

        <oct-form-group label="電話番号">
          <oct-text-field
            helperText="+81 3 6666 9699"
            v-model="$data.$_octSelectionDialog_venue.tel"
          />
        </oct-form-group>

        <oct-form-group>
          <oct-form-row>
            <oct-form-col dense>
              <oct-form-group label="開館時間">
                <oct-select
                  :items="$data.$_octSelectionDialog_hourOptions"
                  v-model="$data.$_octSelectionDialog_venue.openingTime"
                />
              </oct-form-group>
            </oct-form-col>
            <oct-form-col dense>
              <oct-form-group label="閉館時間">
                <oct-select
                  :items="$data.$_octSelectionDialog_hourOptions"
                  v-model="$data.$_octSelectionDialog_venue.closingTime"
                />
              </oct-form-group>
            </oct-form-col>
          </oct-form-row>
        </oct-form-group>

        <oct-form-group label="休館日">
          <oct-form-row column>
            <oct-form-col
              v-for="(item, i) in $data.$_octSelectionDialog_venue.holidays"
              :cols="4"
              :key="i"
              removable
              :reducible="i > 0"
              @increase="onHolidayIncrease"
              @decrease="onHolidayDecrease(i)"
            >
              <oct-select
                :items="$data.$_octSelectionDialog_dayOptions"
                v-model="$data.$_octSelectionDialog_venue.holidays[i]"
              />
            </oct-form-col>
          </oct-form-row>
        </oct-form-group>

        <oct-form-group label="入館料">
          <oct-form-row>
            <oct-form-col>
              <oct-form-group>
                <oct-radio
                  label="Free"
                  value=""
                  v-model="$data.$_octSelectionDialog_venue.admissionFee"
                />
              </oct-form-group>
            </oct-form-col>

            <oct-form-col dense>
              <oct-form-group>
                <oct-radio
                  :value="$data.$_octSelectionDialog_venue.admissionFee ? $data.$_octSelectionDialog_venue.admissionFee : 0"
                  v-model="$data.$_octSelectionDialog_venue.admissionFee"
                />
              </oct-form-group>
            </oct-form-col>

            <oct-form-col dense>
              <oct-form-group>
                <oct-text-field
                  :cols="4"
                  v-model="$data.$_octSelectionDialog_venue.admissionFee"
                />

                <template #text>
                  yen
                </template>
              </oct-form-group>
            </oct-form-col>
          </oct-form-row>
        </oct-form-group>

        <oct-form-group label="備考：英語">
          <oct-text-field
            v-model="$data.$_octSelectionDialog_venue.data.businessNoteEN"
            :rows="3"
          />
        </oct-form-group>

        <oct-form-group label="備考：日本語">
          <oct-text-field
            v-model="$data.$_octSelectionDialog_venue.data.businessNote"
            :rows="3"
          />
        </oct-form-group>
      </oct-form>
    </div>
  </oct-dialog>
</template>

<script>
import OctApiAdaptor from '@/components/api-adaptor/OctApiAdaptor.js'
import OctComponent from '@/components/base/component'
import OctCheckbox from '@/components/checkbox/OctCheckbox'
import OctRadio from '@/components/radio/OctRadio'
import OctTextField from '@/components/text-field/OctTextField.vue'
import OctSelect from '@/components/select/OctSelect.vue';
import OctForm from '@/components/form/OctForm.vue'
import OctFormRow from '@/components/form/OctFormRow.vue';
import OctFormCol from '@/components/form/OctFormCol.vue';
import OctFormGroup from '@/components/form/OctFormGroup.vue';
import OctMedia from '@/components/media/OctMedia.vue'
import OctList from '@/components/list/OctList.vue'
import OctListItem from '@/components/list/OctListItem.vue'
import OctTabBar from '@/components/tab-bar/OctTabBar'
import OctDialog from '@/components/dialog/OctDialog.vue'

/** Padder */
const pad = (num, d) => (Math.pow(10, d) + Number(num)).toString().substr(1, d)

/** Options for hour selection */
const hourOptions = Array(24).fill(0).reduce((acc, cur, i) => {
  const hour = `${pad(i, 2)}:00`

  // Push an hour
  acc.push({
    text: hour,
    value: `${hour}:00`,
  })

  return acc
}, [{
  text: 'None',
  value: '',
}])

/** Options for day selection */
const dayOptions = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Holiday'].reduce((acc, cur) => {
  // Push a day
  acc.push({
    text: cur,
    value: cur,
  })

  return acc
}, [{
  text: 'None',
  value: '',
}])

const state = {
  artist: {
    items: [],
    page: 1,
    total: 100000
  },
  gallery: {
    items: [],
    page: 1,
    total: 100000
  },
  artwork: {
    items: [],
    page: 1,
    total: 100000
  },
  exhibition: {
    items: [],
    page: 1,
    total: 100000
  },
  artfair: {
    items: [],
    page: 1,
    total: 100000
  },
  platform: {
    items: [],
    page: 1,
    total: 100000
  },
  relatedArtists: {
    items: [],
    page: 1,
    total: 100000
  },
  relatedUsers: {
    items: [],
    page: 1,
    total: 100000
  }
}

export default {
  name: 'OctSelectionDialog',
  mixins: [ OctComponent ],
  components: {
    OctCheckbox,
    OctRadio,
    OctTextField,
    OctSelect,
    OctList,
    OctListItem,
    OctForm,
    OctFormRow,
    OctFormCol,
    OctFormGroup,
    OctMedia,
    OctTabBar,
    OctDialog
  },
  /**
   * @property {array} allowedManualRegistrations - Array of types allowed for manual registration
   */
  props: {
    /** Title */
    title: {
      type: String,
      default: 'ギャラリーを選択'
    },
    /** Search Type [user | gallery | artist | artwork | exhibition | artfair | platform] */
    type: {
      type: String,
      default: 'gallery'
    },
    /** Number of items in one api response */
    counts: {
      type: Number,
      default: 100
    },
    /** Whether can select multiple items */
    multiple: {
      type: Boolean,
      default: true
    },
    /** 
     * Listings allowed for manual registration
     */
     allowedManualRegistrations: {
       type: Array,
       default: () => []
     },
    all: {
      type: Boolean,
      default: false
    },
    /** User grid layout */
    grid: {
      type: Boolean,
      default: false
    },
    /** Access token for Auth0 */
    token: {
      type: String,
      default: ''
    },
    /** Preset query */
    queries: {
      type: Object,
      default: () => {}
    },
    /** Preset selection */
    items: {
      type: Array,
      default: () => []
    },
    /** Display type [list|card] */
    displayType: {
      type: String,
      default: 'list'
    },
    /** Enable place input */
    place: {
      type: Boolean,
      default: false
    },
    /** The user */
    user: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      /** Items retrieved from the API */
      $_octSelectionDialog_items: [],
      /** Related items */
      $_octSelectionDialog_relatedItems: [],
      /** Id list of selected items */
      $_octSelectionDialog_selections: [],
      /**
       * Tab selection
       * Default value is depending on the type
       */
      $_octSelectionDialog_currentTab: this.type === 'user' ? 'gallery' : 'select',
      /** Venue Data */
      $_octSelectionDialog_venue: {
        tradeName: '',
        tradeNameEN: '',
        base: '',
        website: '',
        address: '',
        addressEN: '',
        tel: '',
        openingTime: '',
        closingTime: '',
        holidays: [''],
        admissionFee: '',
        data: {
          businessNote: '',
          businessNoteEN: ''
        }
      },
      /** Artist name */
      $_octSelectionDialog_artistName: (this.items.find(item => item.id === undefined) || {tradeName: ''}).tradeName,
      /** Hour Options */
      $_octSelectionDialog_hourOptions: hourOptions,
      /** Hour Options */
      $_octSelectionDialog_dayOptions: dayOptions
    }
  },
  computed: {
    state: () => state,
    isOrganizer() {
      return this.allowedManualRegistrations.includes('organizer');
    },
    userLength() {
      return this.isOrganizer ? 4 : 3;
    },
  },
  methods: {
    /** Submit Handler */
    submit () {
      let selected = []

      // Get selected items
      // If the current tab is input, use manually input venue
      // Otherwise, use selected items
      if (this.$data.$_octSelectionDialog_currentTab === 'input')
        selected = [this.$data.$_octSelectionDialog_venue]
      else
        this.$data.$_octSelectionDialog_selections.forEach(id => {
          const a =
            this.$data.$_octSelectionDialog_items.find(item => item.id === id) ||
            this.$data.$_octSelectionDialog_relatedItems.find(item => item.id === id)
          a && selected.push(a)
        })

      // If the artist name is sat, add it to the selected items
      if (this.$data.$_octSelectionDialog_artistName)
        selected.push({
          tradeName: this.$data.$_octSelectionDialog_artistName
        })

      // Emit update
      this.$emit('update:items', selected)
    },
    /** Holiday increment handler */
    onHolidayIncrease () {
      this.$data.$_octSelectionDialog_venue.holidays.push('')
    },
    /** Position decrement handler */
    onHolidayDecrease (index) {
      this.$data.$_octSelectionDialog_venue.holidays.splice(index, 1)
    },
    /** Get title from item */
    getTitle (item) {
      return this.getLocaleString(item, 'title') || this.getLocaleString(item, 'tradeName')
    },
    /** Get text from item */
    getText (item) {
      return (this.type === 'gallery' ||
          this.type === 'artfair' ||
          this.type === 'paltform') ? item.base :
          this.type === 'artist' ? item.position.join(', ') :
          this.type === 'artwork' ? this.getLocaleString(item.artists[0], 'tradeName') : item.startDate
    },
    /** Grid item click handler */
    onGridItemClick (event) {
      const label = event.currentTarget.querySelector('label')
      label && !label.contains(event.target) && label.click()
      console.log(label)
    },
    /**
     * Fetch Items from the API
     * @param {string} type Item type to fetch
     */
    async getItems (type=null) {
      // Use global type if argument is not sat
      type = type || this.type

      // Target store to update
      const store = state[type]

      // Already fetched all
      if (store.items.length >= store.total)
        return

      // Query to send
      let queries = Object.assign({
        page: store.page,
        counts: this.counts
      }, this.queries)

      // Add necessary queries
      if (type === 'artist' || type === 'gallery') {
        // Search query
        queries = Object.assign({
          type: type,
          page: store.page,
          counts: this.counts
        }, this.queries)
      }

      try {
        let response = {}

        if (type === 'exhibition') {
          // Fetch exhibitions from API and append to the items
          response = await OctApiAdaptor.getExhibitions(
            // If the user is sat and is art fair account, show art fairs otherwise show exhibitions
            Object.assign({}, queries, {type: this.user && this.user.artfair ? ['artfair'] : ['physical,digital']}),
            this.token
          )
        } else if (type === 'artfair') {
          // Fetch exhibitions from API and append to the items
          response = await OctApiAdaptor.getExhibitions(
            Object.assign({}, queries, {type: ['artfair']}),
            this.token
          )
        } else if (type === 'artwork') {
          // Fetch artworks from API and append to the items
          response = await OctApiAdaptor.getArtworks(queries, this.token)
        } else if (type === 'platform') {
          // Fetch platform from json, only one time
          if (!store.items.length)
            response = await OctApiAdaptor.getPlatforms()
        } else {
          // Fetch users from API and append to the items
          response = await OctApiAdaptor.getUsers(queries, this.token)
        }

        if (response.items && response.items.length) {
          // Add items to all items
          this.$data.$_octSelectionDialog_items = this.$data.$_octSelectionDialog_items.concat(response.items)

          // Store items and increase page
          store.items = store.items.concat(response.items)
          store.total = response.total
          store.page++
        }

        // Fetch items again after three seconds
        setTimeout(() => this.getItems(type), 3000)
      } catch (thrown) {
        alert('システムエラーが発生しました')
        console.log(thrown)
      }
    },
    /** Fetch related items */
    getRelatedItems () {
      if (this.type === 'artist') this.getReletedArtists()
      if (this.type === 'user') this.getReletedUsers()
    },
    /** Fetch related artists */
    async getReletedArtists () {
      let users = []

      try {
        // Promise queue
        const promises = []

        // Recent 20 artworks related to me
        const artworks = await OctApiAdaptor.getArtworks({
          [this.user.type]: this.user.id,
          counts:20,
        }, this.token)

        // Append to related items
        artworks.items.forEach(item => {
          users = users.concat(item.artists || [])
        })

        // Recent 20 artworks related to me
        const exhibitions = await OctApiAdaptor.getExhibitions({
          gallery: this.user.id,
          type: ['digital', 'physical'],
          counts:20,
        }, this.token)

        // Append to related items
        exhibitions.items.forEach(item => {
          promises.push(OctApiAdaptor.getExhibition(item.id, this.token).then(response => {
              users = users.concat(response.artists || [])
          }))
        })

        await Promise.all(promises)
      } catch (thrown) {
        console.error(thrown)
      } finally {
        // Unique
        state.relatedArtists.items = this.$data.$_octSelectionDialog_relatedItems = Array.from(
          new Map(users.map(item => [item.id, item])).values()
        )
        state.relatedArtists.total = state.relatedArtists.items.length
      }
    },
    /** Fetch related users */
    async getReletedUsers () {
      let users = [this.user]

      try {
        // Promise queue
        const promises = []

        // Recent 20 artworks related to me
        const exhibitions = await OctApiAdaptor.getExhibitions({
          gallery: this.user.id,
          type: ['digital', 'physical'],
          counts:20,
        }, this.token)

        // Append to related items
        exhibitions.items.forEach(item => {
          promises.push(OctApiAdaptor.getExhibition(item.id, this.token).
            then(response => {
              users = users.concat(response.artists || []).
                concat(response.venues.filter(venue => venue.id)).
                concat(response.organizers || []).
                concat(response.sponsers || [])
            }))
        })

        await Promise.all(promises)
      } catch (thrown) {
        console.error(thrown)
      } finally {
        // Unique
        state.relatedUsers.items = this.$data.$_octSelectionDialog_relatedItems = Array.from(
          new Map(users.map(item => [item.id, item])).values()
        )
        state.relatedUsers.total = state.relatedUsers.items.length
      }
    },
    /** Get filtered items */
    filterItems (type='gallery') {
      return this.$data.$_octSelectionDialog_items.filter(item => item.type === type)
    }
  },
  mounted () {
    // Target store to update
    const store = state[this.type]

    // Recover from store
    if (this.type === 'user') {
      this.$data.$_octSelectionDialog_items = state.gallery.items.concat(state.artist.items)
      // Fetch related items
      if (!state.relatedUsers.items.length)
        this.getRelatedItems()
      else
        this.$data.$_octSelectionDialog_relatedItems = state.relatedUsers.items
    } else if (this.type === 'artist') {
      this.$data.$_octSelectionDialog_items = store.items
      // Fetch related items
      if (!state.relatedArtists.items.length)
        this.getRelatedItems()
      else
        this.$data.$_octSelectionDialog_relatedItems = state.relatedArtists.items
    } else
      this.$data.$_octSelectionDialog_items = store.items

    // Reflesh selection
    if (this.items.length && !this.items[0].artists && !this.items[0].id) {
      // Case of venue
      this.$data.$_octSelectionDialog_venue = this.items[0]
      this.$data.$_octSelectionDialog_currentTab = 'input'
      this.$data.$_octSelectionDialog_selections = []
    } else {
      // Case of selection
      this.$data.$_octSelectionDialog_selections = this.items.map(item => item.id)

      // Update default tab
      this.$data.$_octSelectionDialog_currentTab =
        (this.type === 'artist' || this.type === 'user' ) ? 'related' : this.$data.$_octSelectionDialog_currentTab
    }

    // Start to retrieve items
    if (this.type === 'user') {
      // Fetch galleries and artists
      this.getItems('artist')
      this.getItems('gallery')
    } else
      // Fetch specified type
      this.getItems()
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-selection-dialog ::v-deep .oct-dialog__surface {
  width: calc(100vw - oct-rem(40));

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  width: oct-rem(550);
}
}

.oct-selection-dialog--grid ::v-deep .oct-dialog__surface {
@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  width: oct-rem(856);
  max-width: none;
}
}

.oct-selection-dialog-list {
  margin: oct-rem(-9) oct-rem(-12);
  display: flex;
  flex-wrap: wrap;
}

.oct-selection-dialog-list-item {
  flex: 0 0 50%;
  max-width: 50%;
  padding: oct-rem(9) oct-rem(12);

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  flex: 0 0 25%;
  max-width: 25%;
}
}

.oct-selection-dialog-list-item__content {
  cursor: pointer;
}

.oct-selection-dialog-list-item__action {
  position: absolute;
  top: oct-rem(12);
  right: oct-rem(12);
  z-index: 2;

  ::v-deep .oct-checkbox--sign .oct-checkbox__background {
    border-color: rgba(255,255,255,.4);
  }

  ::v-deep .oct-checkbox__native-control:checked + .oct-checkbox__background {
    border-color: #000;
  }
}

.oct-selection-dialog-list-item__media {
  margin: 0 0 oct-rem(13);
}

.oct-selection-dialog-list-item__primary-text {
  font-size: oct-rem(15);
  line-height: (20/15);
  margin: oct-rem(-4) 0 oct-rem(-4+8);
  display: block;
}

.oct-selection-dialog-list-item__secondary-text {
  font-size: oct-rem(13);
  line-height: (18/13);
  margin: oct-rem(-4) 0;
  display: block;
  opacity: .55;
}
</style>
